import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnDestroy } from "@angular/core";
import { FramesEntity } from "src/app/models/frames-entity.model";

@Component({
  selector: "collapsible-header-left-sidebar-layout",
  templateUrl: "./collapsible-header-left-sidebar-layout.component.html",
  styleUrls: ["./collapsible-header-left-sidebar-layout.component.scss"],
})
export class CollapsibleHeaderLeftSidebarLayoutComponent implements AfterViewInit, OnDestroy {
  @ViewChild("container") containerRef!: ElementRef;
  @ViewChild("scrollOnTopButton") scrollOnTopButton!: ElementRef;

  @Input() nav?: FramesEntity;
  @Input() header?: FramesEntity;
  @Input() main?: FramesEntity;
  @Input() footer?: FramesEntity;

  constructor() {}

  isSidebarClosed: boolean = false;

  toggleSidebar() {
    this.isSidebarClosed = !this.isSidebarClosed;

    const mainFrameElement = document.querySelector(".main-frame") as HTMLElement;

    // Aggiungi la classe per nascondere la scrollbar
    mainFrameElement.classList.add("main-frame-transition");

    // Rimuovi la classe dopo la transizione
    setTimeout(() => {
      mainFrameElement.classList.remove("main-frame-transition");
    }, 400); // Usa il tempo della transizione
  }

  /**
   * @inheritdoc
   */
  ngAfterViewInit(): void {
    this.calculateDistance();
    window.addEventListener("resize", this.calculateDistance.bind(this));
  }

  /**
   * Calcola la distanza tra il container e il pulsante scrollOnTop.
   */
  calculateDistance(): void {
    if (this.containerRef) {
      const container = this.containerRef.nativeElement;
      const scrollOnTop = this.scrollOnTopButton.nativeElement;
      const containerRect = container.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const distance = viewportWidth - containerRect.right;

      // Posiziona l'elemento a metà di questa distanza o a 30px se la distanza è minore della larghezza di scrollOnTop
      let position;
      if (distance < scrollOnTop.offsetWidth) {
        position = 30;
      } else {
        position = distance / 2 - scrollOnTop.offsetWidth / 2;
      }
      scrollOnTop.style.right = `${position}px`;
    }
  }

  /**
   * @inheritdoc
   */
  ngOnDestroy(): void {
    window.removeEventListener("resize", this.calculateDistance.bind(this));
  }
}
